/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import { numberFieldDefault, requiredValidator } from "../../../../services/validationRules";
import ValidatorTextField from "../../../FormFields/ValidatorTextField";
import ValidatorSelectField from "../../../FormFields/ValidatorSelectField";
import FormLegend from "../../Common/FormLegend/FormLegend";
import NumberFieldConfigured from "../../ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";
import wizardStyle from "../../wizardStyle";

type VehicleProps = {
  path: string;
  index: number;
  product: AbstractCase;
};

export default function Vehicle({ path, index, product }: VehicleProps) {
  return (
    <>
      <Grid item xs={12} sx={wizardStyle.gridTopSpaced}>
        <FormLegend>Bitte geben Sie hier weitere Details zum {index + 1}. Fahrzeug an.</FormLegend>
      </Grid>
      <Grid item xs={12}>
        <ValidatorTextField name={path + ".make"} label="Marke und Typ" validators={[requiredValidator("Bitte geben Sie Marke und Typ an")]} />
      </Grid>
      <Grid item xs={12}>
        <ValidatorTextField
          name={path + ".manufactured"}
          label="Baujahr"
          validators={[requiredValidator("Bitte geben Sie das Baujahr an"), numberFieldDefault]}
        />
      </Grid>
      <Grid item xs={12}>
        <ValidatorTextField
          name={path + ".purchased"}
          label="Anschaffungsjahr"
          validators={[requiredValidator("Bitte geben Sie das Baujahr an"), numberFieldDefault]}
        />
      </Grid>
      <Grid item xs={12}>
        <ValidatorSelectField
          label="Allein- oder Miteigentum"
          name={path + ".ownership"}
          validators={[requiredValidator("Bitte geben Sie die Besitzverhältnisse an")]}
          MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}
        >
          <MenuItem value={"Alleineigentum"}>Alleineigentum</MenuItem>
          <MenuItem value={"Miteigentum"}>Miteigentum</MenuItem>
        </ValidatorSelectField>
      </Grid>
      <Grid item xs={12}>
        <ValidatorTextField name={path + ".mileage"} label="Kilometerstand" validators={[requiredValidator("Bitte geben Sie den Kilometerstand an")]} />
      </Grid>
      <NumberFieldConfigured caseData={product} fieldPath={path + ".value"} fieldType={"money"} required={true} numberType={"float"} />
    </>
  );
}
